import { colors } from '../../../../../../../../../colorVars';
import { Body3 } from '../../../../../../../../../components/atomic/text/Text';

export function inPositionBuilder({parsedStatusObj}) {
  const symbol = parsedStatusObj.symbol;
  return (
    <td>
      <Body3 fontWeight={500} color={colors.lightGrey}>
        Already in position {symbol ? '-' + symbol + '.' : '.'}
      </Body3>
    </td>
  );
}
